import Tools from '../../tools/tools';

export default class Success{
	constructor(view){
		console.log('Success :: init',view);

		this.view 		= view;

		this.cardBrand	= "";
		this.card4LastNumb = 0;
	}

	load(formData){
		Tools.scrollTo(0,$(document.querySelector('.container')).offset().top - 40);
		console.log("RECEIPT: ", formData);

		let user_id 	= this.view.querySelector('.user_id strong'),
			trans_date 	= this.view.querySelector('.trans_date strong'),
			trans_time 	= this.view.querySelector('.trans_time strong'),
			cardBrand 	= this.view.querySelector('.cardbrand'),
			cardLast4 	= this.view.querySelector('.cardlast4 strong'),
			event_date 	= this.view.querySelector('.event_date'),
			event_time 	= this.view.querySelector('.event_time'),
			location 	= this.view.querySelector('.location'),
			duration 	= this.view.querySelector('.duration'),
			packages 	= this.view.querySelector('.package'),
			people 		= this.view.querySelector('.people'),
			option 		= this.view.querySelector('.option'),
			st 			= this.view.querySelector('.st'),
			$taxes 		= this.view.querySelector('.taxes'),
			total2 		= this.view.querySelector('.row.total span'),
			customer 	= this.view.querySelector('.customer'),
			billing 	= this.view.querySelector('.billing');

		let time = formData.transaction.date.raw;
		let timeSplit = time.split(' ');

		user_id.innerHTML 		= formData.transaction.id;
		trans_date.textContent 	= formData.transaction.date.formatted;
		trans_time.innerHTML 	= timeSplit[1];
		cardBrand.innerHTML 	= this.cardBrand;
		cardLast4.innerHTML 	= "**** " + this.card4LastNumb;
		event_date.innerHTML 	= formData.receipt.date.formatted;
		event_time.innerHTML 	= formData.receipt.time;
		location.innerHTML 		= formData.receipt.location;
		duration.innerHTML 		= formData.receipt.duration;
		packages.innerHTML 		= formData.receipt.package;
		people.innerHTML 		= formData.receipt.passengers;
		option.innerHTML 		= formData.receipt.option;
		st.innerHTML 			= formData.transaction.totals.subtotal;
		total2.innerHTML 		= formData.transaction.totals.total;

		//taxes
		$taxes.querySelectorAll('.tax').forEach(tax =>{
			tax.remove();
		})
		let taxes = formData.transaction.totals.taxes;

		for(let key in taxes){
			let row = document.createElement('div');
			let col1 = document.createElement('div');
			let col2 = document.createElement('div');
			row.classList.add('row');
			row.classList.add('tax');
			col1.classList.add('col');
			col2.classList.add('col');

	        col1.innerHTML = taxes[key].name;
	        col2.innerHTML = taxes[key].amount;

			row.appendChild(col1);
			row.appendChild(col2);
			$taxes.appendChild(row);
		}
		if(taxes.length == 0) $taxes.remove();

		let pC = document.createElement('p');
		let	firstC = pC.cloneNode(true);
		let	companyC = pC.cloneNode(true);
		let secondC = pC.cloneNode(true);
		let thirdC = pC.cloneNode(true);
		let fourthC = pC.cloneNode(true);
		let fifthC = pC.cloneNode(true);

		let appC = formData.receipt.customer.appartement ? ", " + formData.receipt.customer.apartement : "";
		let company = formData.receipt.customer.company ? formData.receipt.customer.company : "";

		firstC.innerHTML = formData.receipt.customer.name;
		if(company) companyC.innerHTML = company;
		secondC.innerHTML = formData.receipt.customer.address +  appC;
		thirdC.innerHTML = formData.receipt.customer.city + ", " + formData.receipt.customer.province + ", "+ formData.receipt.customer.country + ", " + formData.receipt.customer.zipcode ;
		fourthC.innerHTML = formData.receipt.customer.phone;
		fifthC.innerHTML = formData.receipt.customer.email;

		customer.querySelector('address').appendChild(firstC);
		if(company) customer.querySelector('address').appendChild(companyC);
		customer.querySelector('address').appendChild(secondC);
		customer.querySelector('address').appendChild(thirdC);
		customer.querySelector('address').appendChild(fourthC);
		customer.querySelector('address').appendChild(fifthC);

		billing.querySelector('.title').innerHTML = formData.receipt.location;
		let pB = document.createElement('p');
		let secondB = pB.cloneNode(true);
		let thirdB = pB.cloneNode(true);
		let fourthB = pB.cloneNode(true);
		let fifthB = pB.cloneNode(true);

		let billingAddress 	= formData.billing.address ? formData.billing.address : "";
		let billingCity 	= formData.billing.city ? formData.billing.city : "";
		let billingProvince = ", " + formData.billing.province ? formData.billing.province : "";
		let billingCountry 	= ", " + formData.billing.country ? formData.billing.country : "";
		let billingZipcode 	= ", " + formData.billing.zipcode ? formData.billing.zipcode : "";
		let billingPhone 	= formData.billing.phone ? formData.billing.phone : "";
		let billingEmail 	= formData.billing.email ? formData.billing.email : "";

		secondB.innerHTML 	= billingAddress;
		thirdB.innerHTML 	= billingCity + billingProvince + billingCountry + billingZipcode;
		fourthB.innerHTML 	= billingPhone;
		fifthB.innerHTML 	= billingEmail;

		// billing.querySelector('address').appendChild(firstB);
		if(billingAddress) billing.querySelector('address').appendChild(secondB);
		if(billingCity || billingProvince || billingCountry || billingZipcode) billing.querySelector('address').appendChild(thirdB);
		if(billingPhone) billing.querySelector('address').appendChild(fourthB);
		if(billingEmail) billing.querySelector('address').appendChild(fifthB);
	}

}